export const ORGANISATION_LABEL_NAME_PATTERN =
  /^[\w\s+\-./()#&_@,;:!?'"%*=[\]{}<>|\\~^`$]+$/u;

export const DISALLOWED_LABEL_CHARACTER_PATTERN =
  /[^\w\s+\-./()#&_@,;:!?'"%*=[\]{}<>|\\~^`$]/gu;

export const ITERATION_LABELS_ACCORDION_KEY = 'iteration-labels';

export const LABEL_MAX_LENGTH = 50;

export const ITERATION_LABEL_MESSAGES = {
  Empty: "Label name can't be empty.",
  Duplicate: 'This label already exists.',
  EmptyState: 'No labels yet. Add a label to get started.',
  NoMatch: 'No labels match.',
  Saved: 'Label saved.',
  Deactivated: 'Label deactivated.',
  Activated: 'Label activated.',
  SaveError: "Couldn't save label. Please try again.",
} as const;
